import { FundingEnumType } from '@app-types/funding';

export function getFundingLabels(fundingType: FundingEnumType): string {
    switch (fundingType) {
        case FundingEnumType.COMPTANT:
            return 'Comptant';
        case FundingEnumType.EDP:
            return 'Facilité de paiement sans frais';
        default: {
            return 'Financement smartphone';
        }
    }
}
